<!--ALREADY HAVE AN USER ACCOUNT-->
<!--NOTE: This only appears if user is not logged in. Clicking on link takes user to the sign in or login page-->
<ng-container *ngIf="user">
  <section
    class="login-shortcut-banner margin-top-offset padding-top-large padding-bottom-large margin-left-large margin-right-large">
    <!--LAPTOP ICON-->
    <div class="margin-right-small"><i class="icon red laptop-arrow medium"></i></div>
    <!--END LAPTOP ICON-->
    <!--MESSAGE-->
    <p class="medium">
      <span class="bold">Already have an account?</span>
      Existing users and subscribers can
      <a class="gen-primary-link--accesible with-underline" routerLink="/login"> log in here </a>
      to access courses.
    </p>
    <!--END MESSAGE-->
  </section>
</ng-container>
<!--END ALREADY HAVE AN USER ACCOUNT-->
